import { ChangeEvent, useState } from 'react';

export interface CheckGroup<T> {
  init: (values: T[], defaultValues?: T[]) => void;
  isEmpty: () => boolean;
  isChecked: (value: T) => boolean;
  isAllChecked: () => boolean;
  isNoneChecked: () => boolean;
  onCheck: (event: ChangeEvent<HTMLInputElement>, value: T) => void;
  onCheckAll: (event: ChangeEvent<HTMLInputElement>) => void;
  getCheckedValues: () => T[];
}

/**
 * hook for checkbox group
 *
 * @returns CheckGroup
 */
export default function useCheckGroup<T>() {
  const [groupValues, setGroupValues] = useState<T[]>([]);
  const [checkedValues, setCheckedValues] = useState<T[]>([]);

  const init = (values: T[] = [], defaultValues: T[] = []) => {
    // let defaultVl = typeof defaultValues !== 'undefined' ? defaultValues : [];
    setGroupValues(values);
    setCheckedValues(defaultValues);
  }

  const onCheckAll = (event: ChangeEvent<HTMLInputElement>) => {
    const values = event.target.checked ? groupValues : [];
    setCheckedValues(values);
  };

  const onCheck = (event: ChangeEvent<HTMLInputElement>, value: T) => {
    let newCheckedValues = checkedValues.slice();
    if (event.target.checked) {
      newCheckedValues.push(value);
    } else {
      newCheckedValues = newCheckedValues.filter(item => String(item) !== String(value));
    }
    setCheckedValues(Array.from(new Set(newCheckedValues)));
  };

  const isEmpty = () => groupValues.length === 0;

  const checkGroup: CheckGroup<T> = {
    init,
    isEmpty,
    isChecked: (value: T) => checkedValues.some(item => String(item) === String(value)),
    isAllChecked: () => !isEmpty() && groupValues.length === checkedValues.length,
    isNoneChecked: () => checkedValues.length === 0,
    onCheck,
    onCheckAll,
    getCheckedValues: () => checkedValues
  };

  return { checkGroup };
}
